import React, { useEffect, useId, useRef, useState } from "react";
import { NavLink, useLocation } from "react-router-dom";

export const AfishaMoreMenu = () => {
  const { pathname } = useLocation();
  const [open, setOpen] = useState(false);
  const sectionActive = pathname === "/about" || pathname === "/channels";
  const rootRef = useRef<HTMLDivElement>(null);
  const menuId = useId();

  useEffect(() => {
    if (!open) return;

    const onPointerDown = (event: MouseEvent | TouchEvent) => {
      const target = event.target as Node | null;
      if (rootRef.current && target && !rootRef.current.contains(target)) {
        setOpen(false);
      }
    };

    const onKeyDown = (event: KeyboardEvent) => {
      if (event.key === "Escape") setOpen(false);
    };

    document.addEventListener("mousedown", onPointerDown);
    document.addEventListener("touchstart", onPointerDown);
    document.addEventListener("keydown", onKeyDown);
    return () => {
      document.removeEventListener("mousedown", onPointerDown);
      document.removeEventListener("touchstart", onPointerDown);
      document.removeEventListener("keydown", onKeyDown);
    };
  }, [open]);

  return (
    <div className="afisha__more" ref={rootRef}>
      <button
        type="button"
        className={
          "afisha__more-btn" +
          (open ? " afisha__more-btn--open" : "") +
          (sectionActive ? " afisha__more-btn--active" : "")
        }
        aria-haspopup="menu"
        aria-expanded={open}
        aria-controls={menuId}
        onClick={() => setOpen((prev) => !prev)}
      >
        Ещё
        <i className="bi bi-chevron-down" aria-hidden />
      </button>

      {open && (
        <ul className="afisha__more-menu" id={menuId} role="menu">
          <li role="none">
            <NavLink
              to="/channels"
              role="menuitem"
              className={({ isActive }) =>
                "afisha__more-item" +
                (isActive ? " afisha__more-item--active" : "")
              }
              onClick={() => setOpen(false)}
            >
              Каналы
            </NavLink>
          </li>
          <li role="none">
            <NavLink
              to="/about"
              role="menuitem"
              className={({ isActive }) =>
                "afisha__more-item" +
                (isActive ? " afisha__more-item--active" : "")
              }
              onClick={() => setOpen(false)}
            >
              О проекте
            </NavLink>
          </li>
        </ul>
      )}
    </div>
  );
};
